import { IPoint } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ILocationPropertyEditable, instanceOfILocationPropertyEditable } from "./ILocationPropertyEditable";
import { ISizePropertyEditable, instanceOfISizePropertyEditable } from "./ISizePropertyEditable";

export interface IRectangleCoordinateEditable extends ILocationPropertyEditable, ISizePropertyEditable {
  topLeft(): IPropertyEditable<IPoint>;
  center(): IPropertyEditable<IPoint>;
  bottomRight(): IPropertyEditable<IPoint>;
}

export function instanceOfIRectangleCoordinateEditable(instance: any): instance is IRectangleCoordinateEditable {
  return instance
      && instance.topLeft
      && instanceOfIPropertyEditable<IPoint>(instance.topLeft())
      && instance.center
      && instanceOfIPropertyEditable<IPoint>(instance.center())
      && instance.bottomRight
      && instanceOfILocationPropertyEditable(instance)
      && instanceOfISizePropertyEditable(instance);
}
